// 航点模式
export default {
    normal: 'обычный',
    hover: 'зависание',
    land: 'Посадка',
    returnStarting: 'обратный рейс',
    returnHome: 'отправляться в обратный рейс',
    parkingInteraction: 'Взаимодействие с парковкой',
}